import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/Startseite.css";
import { motion } from "framer-motion";
import libraryImage from "../assets/libraryimage.png";

const Startseite = () => {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    if (!query.trim()) return;
    navigate(`/buchsuche?titel=${encodeURIComponent(query)}`);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className="startseite">
      <div className="hero-card">
        <div className="willkommen-section">
          <div className="hero-text">
            <h1>Willkommen bei</h1>
            <h1>der Bibliothek</h1>
            <p>Finden Sie Bücher, Hörbücher und mehr</p>

            <div className="hero-search">
              <motion.input
                layoutId="search-input-field" // <--- WICHTIG: Dieselbe ID wie auf der Zielseite
                type="text"
                placeholder="Bücher suchen..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyDown={handleKeyDown}
                // NEU: Exakt dieselbe Transition wie in der Buchsuche
                transition={{
                  type: "spring",
                  stiffness: 50,
                  damping: 15,
                  mass: 1.2,
                }}
                // Optional: Verhindert, dass die Animation beim ersten Laden der Seite abspielt (nur beim Wechsel)
                initial={false}
              />
              <button onClick={handleSearch}>🔍</button>
            </div>
          </div>
        </div>

        <div className="hero-illustration">
          <img src={libraryImage} alt="Lesende Person" />
        </div>
      </div>
    </div>
  );
};

export default Startseite;
